import { j as s } from "../../../../jsx-runtime-B6kdoens.js";
import { forwardRef as o } from "react";
import { I as t } from "../../../../IconBase-CxZyIWw2.js";
const m = o((e, r) => /* @__PURE__ */ s.jsx(
  t,
  {
    ref: r,
    ...e,
    image: (a) => /* @__PURE__ */ s.jsxs(
      "svg",
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 16,
        height: 16,
        fill: "none",
        viewBox: "0 0 16 16",
        ...a,
        children: [
          /* @__PURE__ */ s.jsxs(
            "mask",
            {
              id: "mask0_2974_3576",
              width: 16,
              height: 12,
              x: 0,
              y: 2,
              maskUnits: "userSpaceOnUse",
              style: {
                maskType: "alpha"
              },
              children: [
                /* @__PURE__ */ s.jsx(
                  "path",
                  {
                    fill: "currentColor",
                    d: "M15.25 2H.75C.34 2 0 2.34 0 2.75v10.44c0 .41.34.75.75.75h14.5c.41 0 .75-.34.75-.75V2.75c0-.41-.34-.75-.75-.75m-.75 1.5v7.23C11.95 9.21 8.72 9.11 8 9.11c-2.4 0-4.65.6-6.5 1.69V3.5zm-.17 8.94H1.72c1.69-1.16 3.94-1.83 6.28-1.83 1.9 0 4.6.5 6.33 1.83"
                  }
                ),
                /* @__PURE__ */ s.jsx(
                  "path",
                  {
                    fill: "currentColor",
                    d: "M11.45 8.55c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2a2 2 0 0 0 2 2m0-2.5c.28 0 .5.22.5.5s-.22.5-.5.5-.5-.22-.5-.5.22-.5.5-.5"
                  }
                )
              ]
            }
          ),
          /* @__PURE__ */ s.jsx("g", { mask: "url(#mask0_2974_3576)", children: /* @__PURE__ */ s.jsx("path", { fill: "currentColor", d: "M0 0h16v16H0z" }) })
        ]
      }
    )
  }
));
m.displayName = "AgencyImageIcon";
export {
  m as AgencyImageIcon,
  m as default
};
//# sourceMappingURL=index.js.map
